import React, { ComponentProps, FC } from 'react'

export type KeyInputProps = ComponentProps<'input'> & {
  placeholderColor?: string
  useBaseClasses?: boolean
  isTextarea?: boolean
}

const base = `input`

const normal = 'input-sm input-bordered w-full'

const focus = 'focus:border-gray-200 focus:ring-gray-400'

const disabled = 'disabled:bg-gray-200 disabled:border-gray-200 disabled:text-gray-400'

const readOnly =
  'read-only:bg-transparent read-only:border-transparent read-only:text-gray-200 read-only:focus:ring-transparent read-only:focus:border-transparent'

const error = 'invalid:border-error invalid:focus:ring-transparent invalid:focus:border-error'

export const baseInputClasses = [base, normal, error].join(' ')

/**
 * @deprecated key-* components are no longer supported.
 */
export const KeyInput: FC<KeyInputProps> = (props) => {
  const {
    className,
    placeholderColor = 'text-gray-400',
    useBaseClasses = true,
    isTextarea = false,
    ...inputProps
  } = props

  // const [focused, setFocused] = useState(false)

  return (
    <>
      {isTextarea ? (
        <textarea
          className={`${
            useBaseClasses && baseInputClasses
          } placeholder:text-${placeholderColor} ${className}`}
          // onFocus={() => setFocused(true)}
          // onBlur={() => setFocused(false)}
          {...(inputProps as any)}
        />
      ) : (
        <input
          type={'text'}
          className='input input-sm input-bordered w-full'
          // onFocus={() => setFocused(true)}
          // onBlur={() => setFocused(false)}
          {...inputProps}
        />
      )}
    </>
  )
}
